<template>
  <b-modal id="modal-cadastro-disciplina" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Cadastrar Disciplina</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastro-disciplina')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <div class="row">
        <div class="col-12 col-md-12">
          <form-group id="nomedisciplina"  label="Disciplina" :text="{ required: 'Obrigatório informar o nome da disciplina' }" :field="$v.disciplina.disciplina">
            <input type="text" class="form-control" id="nomedisciplina" placeholder="Nome da disciplina" v-model="disciplina.disciplina" value="" />
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <form-group id="descricao"  label="Descricao" :text="{ required: 'Obrigatório informar a descrição' }" :field="$v.disciplina.descricao">
            <input type="text" class="form-control" id="descricao" placeholder="Descrição" v-model="disciplina.descricao" value="" />
          </form-group>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="categoria">Categorias</label>
            <multiselect
              v-model="disciplina.categoria"
              :options="categoriasSelecionaveis"
              :multiple="false"
              :close-on-select="true"
              :clear-on-select="false"
              :show-labels="false"
              :preselect-first="false"
              placeholder="Selecionar"
              label="categoria"
              track-by="categoria"
              :block-keys="['Tab','Enter']"
            >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span  class="option__title">
                      {{ props.option.categoria }}
                    </span>
                  </div>
                </template>
            </multiselect>
          </div>
        </div>
        <div class="col-md-12 mb-3" v-if="this.disciplina.imagem">
          <p>Imagem atual da Disciplina</p>
          <img :src="obterUrlS3(this.disciplina.imagem)" alt="" srcset="">
        </div>
        <div class="col-md-12 mb-3" v-else>
          <p>Disciplina sem imagem cadastrada</p>
        </div>
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="imagemCurso">Adicionar imagem da Disciplina</label>
            <div class="input-group mb-3">
              <b-form-file
                v-model="disciplina.imagem"
                placeholder="Escolha uma imagem"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="image/jpeg, image/png"
              ></b-form-file>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastro-disciplina')"><i class="fas fa-chevron-left"></i> Voltar e Cancelar</a>
          <a v-if="isEdicao()" href="javascript:void(0)" class="btn btn-secondary ml-3" @click="excluir"><i class="fa fa-trash"></i> Excluir</a>
          <button v-if="isEdicao()" class="btn btn-primary ml-3" type="button" @click="cadastrarDisciplina">Editar</button>
          <button v-else class="btn btn-primary ml-3" type="button" @click="cadastrarDisciplina">Salvar</button>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import DisciplinaAPI from '@/api/disciplina-api'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import UrlUtils from '@/core/util/url-utils'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'modalCadastroDisciplina',
  components: {
    FormGroup, Multiselect
  },
  inheritAttrs: false,
  props: {
    disciplinaEdicao: Object,
    categorias: Array
  },
  data () {
    return {
      disciplina: {
        id: '',
        disciplina: '',
        imagem: '',
        categoria: ''
      }
    }
  },

  computed: {
    categoriasSelecionaveis () {
      return this.categorias.filter(item => item.id !== 0)
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()
      if (this.isEdicao()) {
        this.disciplina = Object.assign({}, this.disciplinaEdicao)
        this.categorias &&
        this.categorias.map(categoria => {
          if (categoria.id === this.disciplina.categoria.categoria_id) {
            this.disciplina.categoria = categoria
          }
        })
      } else {
        this.disciplina = {
          id: '',
          disciplina: '',
          imagem: ''
        }
      }
    })
  },

  validations: {
    disciplina: {
      disciplina: { required },
      descricao: { required }
    }
  },

  methods: {
    isEdicao: function () {
      return this.disciplinaEdicao && this.disciplinaEdicao.id > 0
    },

    show: function () {
      this.$bvModal.show('modal-cadastro-disciplina')
    },

    obterUrlS3: function (arquivo) {
      if (arquivo.includes('disciplinas-app/') !== false) {
        return UrlUtils.obterUrlS3(arquivo)
      } else {
        return UrlUtils.obterUrlS3('disciplinas-app/' + arquivo)
      }
    },

    excluir: function () {
      const loader = this.$loading.show()
      DisciplinaAPI.excluirDisciplinas(this.disciplina.id).then(data => {
        loader.hide()

        Swal.fire({
          icon: 'success',
          showCloseButton: true,
          text: 'Disciplina excluida com sucesso!'
        }).then(() => {
          this.$bvModal.hide('modal-cadastro-disciplina')
          this.$emit('disciplinaSalva')
        })
      }).catch(error => ResponseUtils.handleError(error, loader))
    },

    cadastrarDisciplina: function () {
      this.$v.disciplina.$touch()
      if (!this.$v.disciplina.$invalid) {
        const loader = this.$loading.show()
        if (this.isEdicao()) {
          DisciplinaAPI.editarDisciplinas(this.disciplina).then(data => {
            loader.hide()

            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Disciplina editada com sucesso!'
            }).then(() => {
              this.$bvModal.hide('modal-cadastro-disciplina')
              this.$emit('disciplinaSalva')
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        } else {
          DisciplinaAPI.salvarDisciplinas(this.disciplina).then(data => {
            loader.hide()

            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Disciplina criada com sucesso!'
            }).then(() => {
              this.$bvModal.hide('modal-cadastro-disciplina')
              this.$emit('disciplinaSalva')
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
        }
      }
    }
  }
}
</script>
